import create from 'zustand';
import { SearchColumnsState, SearchColumnsVisibility } from './interfaces/SearchColumnsState';

export const defaultSearchColumnsVisibility: SearchColumnsVisibility = {
  id: true,
  deadline: true,
  status: true,
  translation: true,
  source: true,
  issue: true,
  language: false,
  xtmProjectName: false,
  filename: false,
  submitterGroupName: false,
  projectName: false,
  projectManager: false,
  qualityExpert: false,
  qmContact: false,
  assignee: false,
  creator: false,
  queryCreatedAt: false,
  loio: false,
  repository: false,
  collection: false,
  stringId: false,
  queryTrackerId: false,
  account: false,
  applicationComponent: false,
  substitutePm: false,
  sourceContact: false
};

export const useSearchColumnsStore = create<SearchColumnsState>((set) => ({
  searchColumnsVisibility: { ...defaultSearchColumnsVisibility },
  hasChangedColumnVisibility: false,
  setSearchColumnsVisibility: (value: SearchColumnsVisibility) =>
    set(() => ({ searchColumnsVisibility: value })),
  setHasChangedColumnVisibility: (value: boolean) =>
    set(() => ({ hasChangedColumnVisibility: value }))
}));
